import api from "utils/api";

const createPaymentIntention = async (data) => {
  const response = await api.createPaymentIntention(data);
  return response.data;
};

export default createPaymentIntention;
